//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "WasteCollectItemModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "废液收集明细表单",
      tableName: "om_waste_collect_item",
      form_fields: ['collectId', 'assetId', 'quantity', 'remark'],
      form_fields_time: [],
      validatorRules: {
        collectId: {
          rules: [{
            required: true,
            message: '请输入收集id!'
          }]
        },
        assetId: {
          rules: [{
            required: true,
            message: '请输入设备资产ID!'
          }]
        },
        quantity: {
          rules: [{
            required: true,
            message: '请输入废液量（L）!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};